let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("goX36")).then(() => parcelRequire('dHHKW'));